module.exports = __webpack_public_path__ + "img/sail.82a3460e.jpg";